export default class DownloadAppState {

}